// Dependencies imports
import React, { useState } from "react";
import swal from "sweetalert";

import { Constants } from "../../../config/Constants";
import config from "../../../config/aws-exports";
import { API } from "aws-amplify";
// import { useSelector } from "react-redux";
// import { authData } from "../../../redux/auth/authSlice";
import CircularProgress from "@mui/material/CircularProgress";

// Local imports

// Styles imports
import Add from "./DeleteEventTenant.module.scss";



const DeleteUser = (props) => {
  let { handleDeleteClose, deleteData, getTenants } = props;
  const [spin, setSpin] = useState(false);
  //const classes = useStyles();

  //let userDetails = useSelector(authData);
  console.log("deleteData", deleteData);

  const onsubmit = () => {
    deleteEvent();
  };

  async function deleteEvent() {
    setSpin(true);
    const bodyParam = {
      body: {
        st_id : deleteData.st_id,
        oid: deleteData.tenantname,
        did: deleteData.tenant,
        mt_id: 1,
        atype: 2,
        schema: Constants.SCHEMA_NAME,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    console.log("bd" + JSON.stringify(bodyParam.body));
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.UPDATE_TENANT,
        bodyParam
        //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
      );
      // const users = response;
      console.log(JSON.stringify(response));
      getTenants();
      handleDeleteClose();
      
      if (response === "Database error: update or delete on table \"sub_tenants\" violates foreign key constraint \"oid\" on table \"users\""){
        swal({
            title: "Oops!",
            text: "This cannot be deleted as the tenant has users",
            icon: "warning",
            dangerMode: false,
            closeOnClickOutside: false,
          }).then((willDelete) => {
            if (willDelete) {
              setSpin(false);
            }
          });
      }
      else {
        swal({
            title: "Success",
            text: "Organizaion Deleted Successfully",
            icon: "success",
            dangerMode: false,
            closeOnClickOutside: false,
          }).then((willDelete) => {
            if (willDelete) {
              setSpin(false);
            }
          });
      }
      
    } catch (error) {
      setSpin(false);
      swal({
        title: "Oooops!",
        text: "Something went wrong!",
        icon: "warning",
        dangerMode: true,
        closeOnClickOutside: false,
      }).then((willDelete) => {
        if (willDelete) {
          setSpin(false);
          handleDeleteClose();
        }
      });
      console.log("getUserError", error);
    }
    console.log("Mount");
  }

  

  return (
    <div>
      {spin === false ? (
        <div className={Add.mainpopup} style={{ width: "100%" }}>
          <div className={Add.form}>
            <form>
              <div className={Add.header}>
                Are you sure you want to delete ?
              </div>
              <div
                className={Add.buttonholder}
                style={{
                  display: "flex",
                  gap: "50px",
                  justifyContent: "center",
                  padding: "10px",
                }}
              >
                <button
                  className={Add.buttonno}
                  onClick={() => handleDeleteClose()}
                >
                  No
                </button>
                <button
                  className={Add.buttonyes}
                  //style={{ background: "orange" }}
                  onClick={onsubmit}
                >
                  Yes
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <div className={Add.root}>
          <CircularProgress style={{ color: Constants.main_color_1 }} />
        </div>
      )}
    </div>
  );
};

export default DeleteUser;
